// Firebase SDK setup
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAYuIVz3rLcE0vd0CZqsI6T9vJysV7Hjzc",
  authDomain: "asdflobeta.firebaseapp.com",
  projectId: "asdflobeta",
  storageBucket: "asdflobeta.firebasestorage.app",
  messagingSenderId: "521849444854",
  appId: "1:521849444854:web:b7b28a1a3a1056758d0fd7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Initialize Cloud Functions
const functions = getFunctions(app);
export { functions, httpsCallable };
